module.exports = __webpack_public_path__ + "static/media/sportAvatar__fortnite.ee95e81b.jpg";